import React, {useEffect, useState} from 'react';
import DefaultAppBar from "./AppBar";
import {Box, Typography} from "@mui/material";
import ReactMarkdown from 'react-markdown';
import './News.css';

const apiUrl = 'http://localhost:8080/api/v1/posts/recent';

const News = () => {
    let [posts, setPosts] = useState([]);

    useEffect(() => {
        fetch(apiUrl)
            .then(response => response.json())
            .then(data => setPosts(data));
    }, []);

    return (
        <div>
            <DefaultAppBar/>
            <Box m="50px">
                <Typography
                    variant="h3"
                    component="h1"
                >
                    News
                </Typography>
                <Box my='20px' sx={{
                    display: 'grid',
                }}>
                    {
                        posts.map((post) => {
                            let date = new Date(0);
                            date.setUTCSeconds(post.createdAt);
                            return (
                                <Box key={post.id} padding={2} style={{
                                    borderRadius: 12,
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
                                }}>
                                    <Typography variant="h4" style={{
                                        fontWeight: 500,
                                    }}>
                                        {post.title}
                                    </Typography>
                                    <Typography variant="h6" style={{
                                        fontWeight: 'lighter',
                                    }}>
                                        {date.toLocaleDateString()}
                                    </Typography>
                                    <Typography variant="body1">
                                        <ReactMarkdown>{post.content}</ReactMarkdown>
                                    </Typography>
                                </Box>
                            )
                        })
                    }
                </Box>
            </Box>
        </div>
    );
};

export default News;